<template>
    <div> 
     <CCard class="p-3">
        <div class="row">
            <div class="col-md-4 pl-4" style="margin-top:-5px">
                <h5>Payroll Period</h5>
                <h4 class="mb-1">{{from | date_format}} - {{to | date_format}}</h4>
            </div>
            <div class="col-md-4 pl-4 text-center">
                <h4 class="text-center text-primary">Process Payroll</h4>
            </div>
            <div class="col-md-4 text-right">
                <template v-if="$parent.isPrevBtnDisabled(status, 2)">
                    <a href="javascript:void(0)" class="btn btn-info  mr-2 btn-sm disabled">
                        <i class="fa fa-chevron-left"></i> Previous
                    </a>
                </template>
                <template v-else>
                    <a href="javascript:void(0)" class="btn btn-info mr-2 btn-sm" @click="prevBtn">
                        <i class="fa fa-chevron-left"></i> Previous
                    </a>
                </template>
                <template v-if="included_emp.length == 0">
                    <a href="javascript:void(0)" class="btn btn-info px-4 btn-sm disabled">
                        Next <i class="fa fa-chevron-right"></i> 
                    </a>
                </template>
                <template v-else>
                    <a href="javascript:void(0)" class="btn btn-info px-4 btn-sm" @click="nextBtn">
                        Next <i class="fa fa-chevron-right"></i> 
                    </a>
                </template>
                
            </div>
            
        </div>
     </CCard>
       
        <div class="row mt-2" v-if="employee_with_errors.length && show_alert">
            <div class="col-md-12">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">{{ employee_with_errors.length }} {{employee_with_errors.length > 1 ? 'employees' : 'employee'}} encountered an error! <strong>NET PAY</strong> must be greater than (0) zero.</h4>
                    <ul>
                        <li v-for="(epm,index) in employee_with_errors" :key="index">
                            {{ epm.personnel_name }}
                        </li>
                    </ul>
                    <hr>
                    <small class="mb-0"><em>Payroll changes done in other modules (Charges, Cash Advance, etc.) will not reflect automatically. Regenerate payroll to see changes.</em></small>
                    <button type="button" class="btn-close btn btn-lg" @click="removeAlert" style="position:absolute;top:5px;right:5px" aria-label="Close">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
        
        <CRow>
                <CCol lg="3" class="pr-0 pb-4">
                     <CCard class="p-2" style="min-height:100%;max-height:200px">
                        <div class="card-header pb-2 pt-2 d-flex flex-wrap align-content-center">
                            <div class="form-check mr-5">
                                <input class="form-check-input" :disabled="isUpdate" :checked="empType('direct_hire')" ref="direct_hire_chk" @click="filterEmp($event, 'direct_hire')" type="checkbox">
                                <label class="form-check-label">
                                    <strong class="text-dark">Direct Hired</strong>
                                </label>
                            </div>
                            <div class="form-check mr-5">
                                <input class="form-check-input" :disabled="isUpdate" :checked="empType('outsourced')" ref="outsourced_chk" @click="handleOutsource" type="checkbox">
                                <label class="form-check-label">
                                    <strong class="text-dark pt-2">Outsourced</strong>
                                </label>
                            </div>

                            <div class="form-group d-flex flex-fill mt-2" v-if="showVendors">
                                <select class="form-control" :disabled="isUpdate" placeholder="Select Vendor" @change="filterEmpByVendor" v-model="vendor_selected">
                                    <option value="">All Agency</option>
                                    <option v-for="v in vendor_list" :value="v.id">{{ v.vendor_name }}</option>
                                    
                                </select>
                            </div>
                        </div>
                        <div class="card-header pb-2 pt-2">
                            <div class="form-check mr-5">
                                <input class="form-check-input" @click="selectAllchk" ref="chk_all" type="checkbox" :checked="allIsSelected">
                                <label class="form-check-label">
                                    <strong class="text-dark">Employee</strong>
                                </label>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush" style="overflow-y: auto">
                            <li class="list-group-item" :class="{'list-group-item-info' : form[selected_personnel_id] && (form[selected_personnel_id].personnel_id) == emp.personnel_id}" v-for="(emp, index) in employee_list" :key="index">
                                <div class="form-check">
                                    <input :disabled="isDisabled(emp.personnel_id)" @click="$event => empSelected($event, emp)" class="form-check-input" :checked="isChecked(emp.personnel_id)" type="checkbox" :value="emp.personnel_id" :id="emp.personnel_id">
                                    <label class="form-check-label">
                                        <a href="javascript:void(0)" class="text-danger" v-if="hasError(emp.personnel_id)"  @click="selectEmployee(emp)">{{emp.personnel_name}}</a>
                                        <a href="javascript:void(0)" v-else :class="{'text-dark' : form[selected_personnel_id] && (form[selected_personnel_id].personnel_id) != emp.personnel_id}" @click="selectEmployee(emp)">{{emp.personnel_name}}</a>
                                        
                                    </label>
                                </div>
                            </li>
                        </ul>
                           
                     </CCard>                
                 </CCol>
            
                <CCol lg="9" class="pl-2">
                <CCard class="p-2 mb-2">
                    <CRow class="ml-2 mr-2" v-if="form[selected_personnel_id]">
                        <CCol lg="6">
                            <small title="Employee ID" style="font-size:13px" class="mr-2">Name</small>
                            <h3 title="Employee Name">{{form[selected_personnel_id].personnel_name}}</h3>
                           
                        </CCol>
                        <CCol lg="2">
                            <small style="font-size:13px" class="mr-2">Personnel Type</small>
                             <h5>{{form[selected_personnel_id].personnel_type}}</h5>
                        
                        </CCol>
                        <CCol lg="2">
                            
                            <small style="font-size:13px" class="mr-2">Daily Rate</small>
                             <h5>{{form[selected_personnel_id].daily_rate}}</h5>
                        </CCol>
                        <CCol lg="2">
                            <div class="form-group">
                                <small style="font-size:13px" >Payment Method</small>
                                <select class="form-control" v-model="form[selected_personnel_id].payment_method">
                                 
                                    <option value="ATM">ATM</option>
                                    <option value="CASH">CASH</option>
                                </select>
                            </div>
                            
                        </CCol>
    
                                
                    </CRow>
                    <CRow class="ml-2 mr-2">
                        
    
                    </CRow>
                </CCard>
                <CCard class="p-2">
            <CRow>
               
                <CCol lg="6">
                <fieldset class="fieldset full-line rounded">
                        <legend>Earnings</legend>
                        <CRow >
                                    <CCol lg="12" class="mt-0">
                                        <div class="row">
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;"></label>
                                            </div>  
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;" class="col-form-label">Trips/Days/Hrs</label>
                                            </div>
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;" class="col-form-label">Amount</label>
                                            </div>
                                           
                    
                                      </div>

                                </CCol>
                        </CRow>
                        <CRow >
                                    <CCol lg="12">
                                        <div class="mb-2 row">
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;">Basic Salary</label>
                                             </div>
                                             <div class="col-sm-4">
                                            <input type="number"  class="form-control" v-model="form[selected_personnel_id].basic_salary_qty" > 
                                            </div>
                                            <div class="col-sm-4">
                                            <input disabled type="number" class="form-control" v-model="form[selected_personnel_id].basic_salary_amount" > 
                                            </div>
                                            
                                      </div>
                                   

                                </CCol>
                        </CRow>
                        <CRow >
                                    <CCol lg="12">
                                        <div class="mb-2 row">
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;">Incentives</label>
                                             </div>
                                             <div class="col-sm-4">
                                            <input type="number" v-model="form[selected_personnel_id].incentives" class="form-control" > 
                                            </div>
                                            <div class="col-sm-4">
                                                <input disabled placeholder="-" type="number" class="form-control" > 
                                            </div>
                                           
                                      </div>

                                </CCol>
                        </CRow>
                        <CRow >
                                    <CCol lg="12">
                                        <div class="mb-2 row">
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;">Holiday Pay</label>
                                             </div>
                                             <div class="col-sm-4">
                                            <input type="number" class="form-control" v-model="form[selected_personnel_id].holiday_qty" > 
                                            </div>

                                            <div class="col-sm-4">
                                            <input type="number" class="form-control" @keyup="earningsChange($event, 'holiday_qty_amount')" :value="form[selected_personnel_id].holiday_qty_amount"> 
                                            </div>
                                           
                                      </div>

                                </CCol>
                        </CRow>
                        <CRow >
                                    <CCol lg="12">
                                        <div class="mb-2 row">
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;">Overtime</label>
                                             </div>
                                             <div class="col-sm-4">
                                            <input type="number" disabled class="form-control"> 
                                            </div>

        
                                            <div class="col-sm-4">
                                            <input type="number" class="form-control" @keyup="earningsChange($event, 'overtime')" :value="form[selected_personnel_id].overtime" > 
                                            <div v-if="showAvailableBalance('overtime')">
                                                <small class="balance-note">{{ otLateBalanceNotePrefix('overtime') }}{{ getAvailableBalanceText(form[selected_personnel_id], 'overtime') }}</small>
                                            </div>
                                            </div>
                                           
                                      </div>

                                </CCol>
                                
                        </CRow>
                        <CRow >
                                    <CCol lg="12">
                                        <div class="mb-2 row">
                                            <div class="col-sm-4">
                                            <label style="font-size: 13px;">Allowance</label>
                                             </div>
                                             <div class="col-sm-4">
                                            <input type="number" placeholder="-" disabled class="form-control"> 
                                            </div>

        
                                            <div class="col-sm-4">
                                            <input type="number" class="form-control"  
                                                @keyup="earningsChange($event, 'allowance')" :value="form[selected_personnel_id].allowance" > 
                                            </div>
                                           
                                      </div>

                                </CCol>
                        </CRow>
                        <CRow >
                            <CCol lg="8">
                                <div class="mb-0">
                                    <label class="mb-1" style="font-size: 13px;">Adjustment</label>
                                    <div class="col-sm-12 pl-0">
                                        <v-select
                                            v-model="form[selected_personnel_id].adjustment_id"
                                            multiple
                                            placeholder=""
                                            label="label"
                                            @input="adjustmentChanged"
                                            :options="adjustmentList(form[selected_personnel_id].adjustments)"
                                            
                                        />
                                        <!-- <select class="form-control" @change="adjustmentChanged" v-model="form[selected_personnel_id].adjustment_id">
                                            <option value=""></option>
                                            <option :value="adj.id" v-for="(adj, i) of adjustmentList(form[selected_personnel_id].adjustments)" :key="i">
                                                {{adj.label}}
                                            </option>
                                        </select> -->
                                    </div>
                                </div>
                            </CCol>
                            <CCol lg="4">
                                <label class="mb-1" style="font-size: 13px;">&nbsp; </label>
                                <input disabled type="number" v-model="adjustment_total[selected_personnel_id]" class="form-control" > 
                                <input disabled type="number" v-model="dummy_var[selected_personnel_id]" class="form-control d-none" >     
                            </CCol>
                        </CRow>

                </fieldset>
                <fieldset class="fieldset full-line rounded">
                        <legend>Earnings Summary</legend>
                       
            <CRow >
			    <CCol lg="6">
				    <strong style="font-size:15px"> Total Earnings</strong>
		    	</CCol>
			    <CCol lg="6" class="text-left">
			        <strong style="font-size:15px" >{{ computeTotalEarnings(form[selected_personnel_id]) | number_format('currency')}}</strong>
			    </CCol>
		    </CRow>   
            <CRow >
			    <CCol lg="6">
				    <strong style="font-size:15px"> Total Deductions</strong>
		    	</CCol>
			    <CCol lg="6" class="text-left">
			        <strong style="font-size:15px">{{ computeTotalDeduction(form[selected_personnel_id]) | number_format('currency')}}</strong>
			    </CCol>
		    </CRow>        
             <CRow class="pt-0 mb-2 bg-secondary text-dark">
			    <CCol lg="6">
				    <strong style="font-size:18px"> NET PAY</strong>
		    	</CCol>
			    <CCol lg="6" class="text-left">
			        <strong style="font-size:18px">{{(computeTotalEarnings(form[selected_personnel_id]) - computeTotalDeduction(form[selected_personnel_id])) | number_format('currency')}}</strong>
			    </CCol>
		    </CRow>
               
            </fieldset>
               
       </CCol>
                <CCol lg="6">
                        <fieldset class="fieldset full-line rounded">
                        <legend>Deductions</legend>
                                <CRow >
                                    <CCol lg="6" class="px-1" v-for="(item, index) of deductions" :key="index">
                                        <div class="mb-1">
                                            <small :for="item.model" class="col-sm-3">{{item.label}}</small>
                                            <div class="col-sm-12">
                                            <input type="text"  @keypress="isNumber($event)" class="form-control" :id="item.model" @keyup="deductionChange($event, item.model)" :value="form[selected_personnel_id][item.model]">
                                            </div>
                                            <div class="col-sm-12" v-if="showAvailableBalance(item.model)">
                                                <small class="balance-note">{{ otLateBalanceNotePrefix(item.model) }}{{ getAvailableBalanceText(form[selected_personnel_id], item.model) }}</small>
                                            </div>
                                        </div>
                                    </CCol>
                                    <CCol lg="6" class="text-left">
                                        <strong style="font-size:12px"> Total Deductions</strong>
                                        <h2>{{ computeTotalDeduction(form[selected_personnel_id]) | number_format('currency') }}</h2>
                                    </CCol>
                                </CRow>
                                
                             <CRow >
                                
		                     </CRow>      
                       </fieldset>
                       <CCol lg="12" class="pt-0 mb-2">
                    
                            <a href="javascript:void(0)" v-if="!isChecked(selected_personnel_id)" class="float-right btn btn-success px-2" @click="markPersonnel()">
                                <i class="fa fa-plus mr-1"></i>
                                Add to this payroll
                            </a>

                            <a href="javascript:void(0)" v-if="isChecked(selected_personnel_id)" class="float-right btn btn-danger px-2" @click="excludeFromList()">
                                <i class="fa fa-times mr-1"></i>
                                Exclude from this payroll
                            </a>
                     </CCol>  
                </CCol>
                
            </CRow>
            <div class="step2-reminder mt-2">
                <strong><i class="fa fa-exclamation-circle mr-1"></i>Important Reminder:</strong>
                <div>- Deductions cannot be greater than the available balance.</div>
                <div>- Overtime and Rider Late are prefilled from the OT/Late module when available; adjust only within the Overtime Credited Balance and Rider Late Balance shown.</div>
            </div>
            
        
                </CCard>           
                </CCol>
          
        </CRow>
            
    </div>
</template>
<script>
import config from '../../../config';
import axios from "../../../axios";
import Swal from 'sweetalert2';
import moment from 'moment';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

    export default {
        name : 'step2',
        data() {
            return {
                deductions: [
                    {
                        label : 'Rider Late',
                        model : 'rider_late'
                    },
                    {
                        label : 'Charges',
                        model : 'charges'
                    },
                    {
                        label : 'Meals',
                        model : 'meals'
                    },
                    {
                        label : 'SSS',
                        model : 'sss'
                    },
                    {
                        label : 'SSS Loan',
                        model : 'sss_loan'
                    },
                    {
                        label : 'PHIC',
                        model : 'phic'
                    },
                    {
                        label : 'Pag-ibig',
                        model : 'pag_ibig'
                    },
                    {
                        label : 'Pag-ibig STL',
                        model : 'pag_ibig_stl'
                    },
                    {
                        label : 'Utilities',
                        model : 'utilities'
                    },
                    {
                        label : 'Cash Advance',
                        model : 'cash_advance'
                    },
                    {
                        label : 'Other Deductions',
                        model : 'other_deductions'
                    }
                ],
                earnings_summary: [
                    {
                        label : 'Basic Salary',
                        model : 'basic_salary'
                    },
                    {
                        label : 'Holiday Pay',
                        model : 'holiday_qty'
                    },
                    {
                        label : 'Overtime',
                        model : 'overtime'
                    },
                    {
                        label : 'Allowance',
                        model : 'allowance'
                    },
                    {
                        label : 'Adjustment',
                        model : 'adjustment'
                    },
                    {
                        label : 'Incentive',
                        model : 'incentives'
                    }
                ],
                employee_list: [
                    
                ],
                form : {},
                included_emp: [],
                selected_personnel_id : '',
                models: [],
                adjustment_total : {},
                dummy_var: {},
                employee_with_errors: [],
                show_alert : true,
                vendor_list: [],
                show_vendor: false,
                vendor_selected: '',
                employee_type: null
               
            }
        },
        components: {vSelect},
        props: ['payroll','from','to','status','emp_type','payroll_id'],
        watch: {
            payroll : {
                handler(val) {
                    console.log('WATCH')
                    if(val) {
                        // this.init()
                    }
                },
                deep : false
            },
            
        },
        beforeMount() {
            this.getVendor()
            this.init()          
        },
        computed : {
            isUpdate() {
                return this.payroll_id ? true : false
            },
            empType() {
                return type => this.emp_type.type == type
            },
            isDisabled() {
                return id => {
                    return false
                }
            },
            showVendors() {
                return this.show_vendor
            },
            hasError() {
                return id => {
                    let with_error = this.employee_with_errors.filter(v => v.personnel_id == id);

                    return with_error.length ? true : false
                }
            },
            adjustmentList() {
                return adjustment => {
                    if(adjustment) {
                        let adj = adjustment.split('|');
                        let arr = [];
                        for (let index = 0; index < adj.length; index++) {
                            const element = adj[index].split('_');
                            arr.push({
                                id : element[0],
                                label : element[1],
                                rate : element[2]
                            });
                        }

                        return arr;
                    }
                    else {
                        this.form[this.selected_personnel_id].adjustment_id = null;
                        return [];
                    }
                }
            },
            allIsSelected() {
                return this.included_emp.length == this.employee_list.length
            },
            isChecked() {
                return id => this.included_emp.indexOf(id) >= 0
            },
            
        },
        methods: {
            toNumber(value) {
                return parseFloat(String(value ?? 0).replace(/,/g, '')) || 0;
            },
            getOriginalPayrollAmount(row, model) {
                if (!row?.id) return 0;
                const appliedField = `payroll_applied_${model}`;
                if (row[appliedField] !== undefined && row[appliedField] !== null) {
                    return this.toNumber(row[appliedField]);
                }
                if (!row._originalPayrollAmounts) return 0;
                return this.toNumber(row._originalPayrollAmounts[model]);
            },
            getDeductionBalanceLimit(row, model) {
                const fieldMap = {
                    charges: 'personnel_ledger_CB',
                    sss_loan: 'personnel_ledger_SSSBalance',
                    cash_advance: 'personnel_ledger_CAB',
                    pag_ibig_stl: 'personnel_ledger_PagibigBalance',
                    other_deductions: 'personnel_ledger_OtherDeductionsBalance',
                };
                const field = fieldMap[model];
                if (!field) return null;
                if (row[field] === undefined || row[field] === null || row[field] === '') return null;
                const currentPayrollDeduction = this.getOriginalPayrollAmount(row, model);
                return this.toNumber(row[field]) + currentPayrollDeduction;
            },
            validateDeductionAmount(row, model, input) {
                const limit = this.getDeductionBalanceLimit(row, model);
                if (limit === null) {
                    return { valid: true, limit: null };
                }
                const amount = this.toNumber(input);
                return {
                    valid: amount <= limit,
                    limit,
                };
            },
            validatePersonnelDeductionBalances(row) {
                const trackedModels = ['charges', 'sss_loan', 'cash_advance', 'pag_ibig_stl', 'other_deductions'];
                for (let index = 0; index < trackedModels.length; index++) {
                    const model = trackedModels[index];
                    const check = this.validateDeductionAmount(row, model, row[model]);
                    if (!check.valid) {
                        return { valid: false, model, limit: check.limit, amount: this.toNumber(row[model]) };
                    }
                }
                return { valid: true };
            },
            validatePayrollOTLateAmounts(row) {
                const overtimeInput = this.toNumber(row?.overtime);
                const lateInput = this.toNumber(row?.rider_late);
                const overtimeTotal = this.toNumber(row?.ot_overtime_total);
                const lateTotal = this.toNumber(row?.ot_late_total);
                const overtimeBalance = this.toNumber(row?.ot_balance_overtime) + this.getOriginalPayrollAmount(row, 'overtime');
                const lateBalance = this.toNumber(row?.ot_balance_late) + this.getOriginalPayrollAmount(row, 'rider_late');

                if (overtimeInput > overtimeTotal || overtimeInput > overtimeBalance) {
                    return {
                        valid: false,
                        field: 'overtime',
                        label: 'Overtime',
                        amount: overtimeInput,
                        total: overtimeTotal,
                        balance: overtimeBalance,
                    };
                }
                if (lateInput > lateTotal || lateInput > lateBalance) {
                    return {
                        valid: false,
                        field: 'rider_late',
                        label: 'Rider Late',
                        amount: lateInput,
                        total: lateTotal,
                        balance: lateBalance,
                    };
                }
                return { valid: true };
            },
            validateOTLateInputByModel(row, model, input) {
                const isOvertime = model === 'overtime';
                const isLateDeduction = model === 'rider_late';
                if (!isOvertime && !isLateDeduction) {
                    return { valid: true };
                }

                const amount = this.toNumber(input);
                if (isOvertime) {
                    const total = this.toNumber(row?.ot_overtime_total);
                    const currentPayrollCredit = this.getOriginalPayrollAmount(row, 'overtime');
                    const balance = this.toNumber(row?.ot_balance_overtime) + currentPayrollCredit;
                    const limit = Math.max(0, Math.min(total, balance));
                    return {
                        valid: amount <= total && amount <= balance,
                        limit,
                        label: 'Overtime',
                        amount,
                        total,
                        balance,
                    };
                }

                const total = this.toNumber(row?.ot_late_total);
                const currentPayrollDeduction = this.getOriginalPayrollAmount(row, 'rider_late');
                const balance = this.toNumber(row?.ot_balance_late) + currentPayrollDeduction;
                const limit = Math.max(0, Math.min(total, balance));
                return {
                    valid: amount <= total && amount <= balance,
                    limit,
                    label: 'Rider Late',
                    amount,
                    total,
                    balance,
                };
            },
            getDeductionLabel(model) {
                const found = this.deductions.find((d) => d.model === model);
                return found?.label || model;
            },
            formatDeductionValidationMessage(model, amount, limit) {
                const label = this.getDeductionLabel(model);
                return `${label} deduction is ${amount}, but available balance is only ${limit}.`;
            },
            formatOTLateValidationMessage(label, amount, total, balance) {
                return `${label} amount is ${amount}, but available balance is only ${balance}.`;
            },
            showAvailableBalance(model) {
                return ['charges', 'sss_loan', 'pag_ibig_stl', 'cash_advance', 'other_deductions', 'rider_late', 'overtime'].includes(model);
            },
            otLateBalanceNotePrefix(model) {
                if (model === 'overtime') return 'Overtime Credited Balance: ';
                if (model === 'rider_late') return 'Rider Late Balance: ';
                return 'Available Balance: ';
            },
            getOTLateEffectiveLimit(row, model) {
                const r = row || {};
                if (model === 'overtime') {
                    const total = this.toNumber(r.ot_overtime_total);
                    const currentPayrollCredit = r?.id ? this.toNumber(r.overtime) : 0;
                    const balance = this.toNumber(r.ot_balance_overtime) + currentPayrollCredit;
                    return Math.max(0, Math.min(total, balance));
                }
                if (model === 'rider_late') {
                    const total = this.toNumber(r.ot_late_total);
                    const currentPayrollDeduction = r?.id ? this.toNumber(r.rider_late) : 0;
                    const balance = this.toNumber(r.ot_balance_late) + currentPayrollDeduction;
                    return Math.max(0, Math.min(total, balance));
                }
                return null;
            },
            getAvailableBalanceText(row, model) {
                if (model === 'overtime' || model === 'rider_late') {
                    const limit = this.getOTLateEffectiveLimit(row, model);
                    if (limit === null || limit === undefined) return '-';
                    return this.$options.filters.number_format(limit, 'currency');
                }
                const limit = this.getDeductionBalanceLimit(row || {}, model);
                if (limit === null || limit === undefined) return '-';
                return this.$options.filters.number_format(limit, 'currency');
            },
            preparePayrollRow(row) {
                const prepared = {...row};
                if (prepared.id) {
                    prepared._originalPayrollAmounts = {
                        charges: prepared.charges,
                        sss_loan: prepared.sss_loan,
                        cash_advance: prepared.cash_advance,
                        pag_ibig_stl: prepared.pag_ibig_stl,
                        other_deductions: prepared.other_deductions,
                        overtime: prepared.overtime,
                        rider_late: prepared.rider_late,
                    };
                }
                const pm = prepared.payment_method;
                if (pm === null || pm === undefined || String(pm).trim() === '') {
                    prepared.payment_method = 'CASH';
                }
                return prepared;
            },
            removeAlert() {
                this.show_alert = false;
            },
            init() {
                this.form = {};
                this.included_emp = [];
                this.selected_personnel_id = '';
                this.models = [];
                this.adjustment_total = {};
                
                if(this.emp_type.type == 'outsourced') {
                    this.show_vendor = true;
                    this.vendor_selected = this.emp_type.vendor ?? '';
                }

                this.employee_list = [...this.payroll];

                if(this.employee_list.length) {
                    this.form[this.employee_list[0].personnel_id] = this.preparePayrollRow(this.employee_list[0]);
                    this.selected_personnel_id = this.employee_list[0].personnel_id;

                    // if not view payroll
                    if(!this.employee_list[0].id){
                        this.deductions.forEach(d => {
                            this.form[this.selected_personnel_id][d.model] = this.form[this.selected_personnel_id][d.model] ?? null;
                            this.models[d.model] = null;
                        })
                        this.earnings_summary.forEach(d => {
                            this.form[this.selected_personnel_id][d.model] = this.form[this.selected_personnel_id][d.model] ?? null;
                            this.models[d.model] = null;
                        })
                    }
                    else {
                        this.adjustment_total[this.selected_personnel_id] = this.form[this.employee_list[0].personnel_id].adjustment;
                        this.dummy_var[this.selected_personnel_id] = this.form[this.employee_list[0].personnel_id].adjustment;
                        this.selectAll(true)
                    }

                    
                }  
                else {
                    this.employee_list = {};
                }

                // net pay trapping
                for (let index = 0; index < this.employee_list.length; index++) {
                    const element = this.employee_list[index];
                    let netpay = (this.computeTotalEarnings(element) - this.computeTotalDeduction(element));
                    console.log('NET PAY', netpay)
                    if(netpay < 0) {
                        this.employee_with_errors.push(element);
                    }
                }
            },
            earningsChange(event, model) {
                let val = event.target.value;
                const row = this.form[this.selected_personnel_id] || {};
                if(val == '') {
                    this.$set(this.form[this.selected_personnel_id],model, null)
                    this.$set(this.dummy_var, this.selected_personnel_id, Math.random())
                    return;
                }
                else if(val >= 0)
                    val = parseFloat(val);

                const otLateCheck = this.validateOTLateInputByModel(row, model, val);
                if (!otLateCheck.valid) {
                    Swal.fire({
                        icon: 'warning',
                        title: `${otLateCheck.label} Amount Exceeds Limit`,
                        text: this.formatOTLateValidationMessage(otLateCheck.label, otLateCheck.amount, otLateCheck.total, otLateCheck.balance),
                    });
                    this.$set(this.dummy_var, this.selected_personnel_id, Math.random())
                    return;
                }

                this.$set(this.form[this.selected_personnel_id],model, val)
                this.$set(this.dummy_var, this.selected_personnel_id, Math.random())
               
            },
            deductionChange(event, model) {
                let val = event.target.value;
                const row = this.form[this.selected_personnel_id] || {};
                
                if(val == '')
                    this.$set(this.form[this.selected_personnel_id],model, null)
                else if(val >= 0) {
                    const otLateCheck = this.validateOTLateInputByModel(row, model, val);
                    if (!otLateCheck.valid) {
                        Swal.fire({
                            icon: 'warning',
                            title: `${otLateCheck.label} Amount Exceeds Limit`,
                            text: this.formatOTLateValidationMessage(otLateCheck.label, otLateCheck.amount, otLateCheck.total, otLateCheck.balance),
                        });
                        this.$set(this.dummy_var, this.selected_personnel_id, Math.random())
                        return;
                    }
                    const check = this.validateDeductionAmount(row, model, val);
                    if (!check.valid) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Deduction Amount Exceeds Balance',
                            text: this.formatDeductionValidationMessage(model, this.toNumber(val), check.limit),
                        });
                    } else {
                        this.$set(this.form[this.selected_personnel_id],model, val)
                    }
                }
                
                this.$set(this.dummy_var, this.selected_personnel_id, Math.random())
               
            },
            adjustmentChanged(adjustment) {
                console.log(this.form[this.selected_personnel_id], adjustment)
                let rate = 0;
                if(adjustment?.length) {
                   
                    adjustment.forEach(a => {
                        rate += (a.rate) ? parseFloat(a.rate) : 0;
                    })

                    this.$set(this.form[this.selected_personnel_id],'adjustment', rate);
                    
                }
                else {
                    this.form[this.selected_personnel_id].adjustment = 0;
                    // this.form[this.selected_personnel_id].adjustment_id = [];
                }

                this.$set(this.adjustment_total, this.selected_personnel_id, rate)
               
                
            },
            prevBtn() {
                Swal.fire({
				icon:'warning',
				title: 'Are you sure you want to go back?',
                text: 'Going back will reset your current work.', 
				showCancelButton: true,
				confirmButtonText: `Yes, go back`, 
				
        		reverseButtons: false,

			}).then((result) => { 
				if (result.isConfirmed) {

                    this.$emit('prev',{from:'step2'})
                    // this.init(true);
				}
			})  
                
            },
            nextBtn() {
                
                this.employee_with_errors = [];
                this.show_alert = true;
                if(this.included_emp.length == 0) return;

                console.log(this.included_emp)

                for (let index = 0; index < this.included_emp.length; index++) {
                    const element = this.included_emp[index];
                    const otLateValidation = this.validatePayrollOTLateAmounts(this.form[element]);
                    if (!otLateValidation.valid) {
                        const empName = this.form[element]?.personnel_name || `Personnel #${element}`;
                        Swal.fire({
                            icon: 'warning',
                            title: `${otLateValidation.label} Amount Exceeds Limit`,
                            text: `${empName}: ${this.formatOTLateValidationMessage(otLateValidation.label, otLateValidation.amount, otLateValidation.total, otLateValidation.balance)}`,
                        });
                        return;
                    }
                    const validation = this.validatePersonnelDeductionBalances(this.form[element]);
                    if (!validation.valid) {
                        const empName = this.form[element]?.personnel_name || `Personnel #${element}`;
                        Swal.fire({
                            icon: 'warning',
                            title: 'Deduction Amount Exceeds Balance',
                            text: `${empName}: ${this.formatDeductionValidationMessage(validation.model, validation.amount, validation.limit)}`,
                        });
                        return;
                    }
                    let netpay = (this.computeTotalEarnings(this.form[element]) - this.computeTotalDeduction(this.form[element]));
                    console.log(this.form[element]);
                    console.log('NET PAY', netpay)
                    if(netpay < 0) {
                        this.employee_with_errors.push(this.form[element]);
                    }

                }

                if(this.employee_with_errors.length > 0) return;

                if(this.included_emp.length < this.employee_list.length) {
                    Swal.fire({
                    icon: "warning",
                    title:"Warning!",
                    text: "You have excluded a personnel in this payroll.",
                    showCancelButton: true,
                    cancelButtonColor: 'red',
                    reverseButtons: true,
                    confirmButtonText: `Continue`,
                    allowOutsideClick: false,

                }).then((result) => {
                    if (result.isConfirmed) {
                        for (let index = 0; index < this.included_emp.length; index++) {
                            const element = this.included_emp[index];
                            // if (Object.hasOwnProperty.call(this.form, element)) {
                            //     delete this.form[element];
                            // }

                            for (const key in this.form) {
                                const element = this.form[key];
                                if(this.included_emp.indexOf(element.personnel_id) < 0) {
                                    delete this.form[key];
                                }
                            }
                            
                        }
                        
                        this.$emit('next')
                    }
                });
                }
                else {
                    this.$emit('next')
                }
                
                
            },
            computeTotalDeduction(emp) {
                return this.$parent.computeTotalDeduction(emp);
            },
            computeTotalEarnings(emp) {
                return this.$parent.computeTotalEarnings(emp)
            },
            excludeFromList() {
                this.included_emp.splice(this.included_emp.indexOf(this.selected_personnel_id), 1);
            },
            markPersonnel() {
                this.included_emp.push(this.selected_personnel_id)
            },
            
            selectAllchk(ev) {
                this.selectAll(ev.target.checked)          
                
            },
            getVendor(){
                axios.get(config.api_path+'/reference/vendors-list')
                .then(response => {
                    this.vendor_list = response.data.data;
                });
            },
            handleOutsource(ev) {
                const val = ev.target.checked;
                this.show_vendor = val;
                this.$refs.direct_hire_chk.checked = false;
                this.vendor_selected = '';
                this.employee_type = (val) ? 'outsourced' : null;
                this.included_emp = []; 
                if(val) {
                    this.employee_list.forEach(e => {
                        if(e.employment_type == 'outsourced') {
                            this.included_emp.push(e.personnel_id)
                            if (!Object.hasOwnProperty.call(this.form, e.personnel_id)) {
                                this.form[e.personnel_id] = this.preparePayrollRow(e);
                            }
                        }
                    })
                }
            },
            filterEmpByVendor(ev) {
                const val = ev.target.value;
                this.included_emp = []; 
                console.log(val)
                if(val) {
                    this.employee_list.forEach(e => {
                        if(e.employment_type == 'outsourced' && e.vendor_id == val) {
                            this.included_emp.push(e.personnel_id)
                            if (!Object.hasOwnProperty.call(this.form, e.personnel_id)) {
                                this.form[e.personnel_id] = this.preparePayrollRow(e);
                            }
                        }
                    })
                }
            },
            filterEmp(checked, type, vendor = null) {
                const is_checked = checked.target.checked;
                this.$refs.outsourced_chk.checked = false
                this.show_vendor = false;
                this.vendor_selected = ''
                this.employee_type = (is_checked) ? 'direct_hire' : null;
                
                this.included_emp = []; 
                if(is_checked) {
                    this.employee_list.forEach(e => {
                        if(e.employment_type == type) {
                            this.included_emp.push(e.personnel_id)
                            if (!Object.hasOwnProperty.call(this.form, e.personnel_id)) {
                                this.form[e.personnel_id] = this.preparePayrollRow(e);
                            }
                        }
                    })
                }
                else {
                    this.selectAll(false)    
                }
            },
            selectAll(checked) {
                this.included_emp = []; 
                if(checked) {
                    this.employee_list.forEach(e => {
                        this.included_emp.push(e.personnel_id)
                        if (!Object.hasOwnProperty.call(this.form, e.personnel_id)) {
                            this.form[e.personnel_id] = this.preparePayrollRow(e);
                        }
                    })
                } 
            },
            selectEmployee(emp) {
                this.selected_personnel_id = emp.personnel_id;
                // check if personnel already saved in form variable. to avoid resetting/overwriting inputted values
                if (!Object.hasOwnProperty.call(this.form, emp.personnel_id)) {
                    this.form[emp.personnel_id] = this.preparePayrollRow({...this.models, ...emp});
                    this.form[emp.personnel_id].adjustment_id=[];
                }
            },
            
            empSelected(ev, emp) {
                const checked = ev.target.checked;
                if(checked) {
                    this.included_emp.push(emp.personnel_id);
                    if (!Object.hasOwnProperty.call(this.form, emp.personnel_id)) {
                        this.form[emp.personnel_id] = this.preparePayrollRow({...emp});
                    }
                }
                else
                    this.included_emp.splice(this.included_emp.indexOf(emp.personnel_id), 1)

                this.$refs.chk_all.checked = (this.included_emp.length == this.employee_list.length);
            }
        }
    }
    </script>

    <style scoped>
li.select2-selection__choice {
    max-width: 100%;
    overflow: hidden;
    /*Altered two below to make word wrap work */
    word-wrap: normal !important;
    white-space: normal;
}
ul.select2-selection__rendered {
    padding-right: 12px !important;
}
.step2-info-banner {
    border: 1px solid #dbe7f7;
    background: #f4f8ff;
    color: #315a93;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
}
.balance-note {
    color: #2f9b63;
    font-size: 9px;
    font-weight: 600;
}
.step2-reminder {
    border: 1px solid #ecdca8;
    background: #fff8e9;
    color: #8f6b1e;
    padding: 10px 12px;
    border-radius: 4px;
    font-size: 12px;
}
</style>